// employee/reducers.ts
const initialState = {
    getCollectionsData: [],
    getCollectionsReportData: [],
    getCollectionsUserReportData: [],
    getCollectionsCount: null,
    getCollectionsReportCount: null,
    createCollectionsData: null,
    updateCollectionsData: null,
    getCollectionsMetaMessage: null,
    getCollectionsSuccess: false,
    getCollectionsReportSuccess: false,
    getCollectionsReportFailure: false,

    getCollectionsUserReportSuccess: false,
    getCollectionsUserReportFailure: false,

    createCollectionsSuccess: false,
    createCollectionsFailure: false,
    updateCollectionsSuccess: false,
    updateCollectionsFailure: false,
    deleteCollectionsSuccess: false,
    deleteCollectionsFailure: false,
};

export default function CollectionsReducer(state = initialState, action: any) {
    switch (action.type) {
        case 'GET_COLLECTIONS_SUCCESS': {
            return {
                ...state,
                getCollectionsSuccess: true,
                getCollectionsData: action.payload?.data?.data?.data,
                getCollectionsCount: action.payload?.data?.data?.meta?.total,
                getCollectionsFailure: false,
            };
        }
        case 'GET_COLLECTIONS_FAILURE': {
            return {
                ...state,
                getCollectionsFailure: true,
                getCollectionsMetaMessage: action.payload?.data?.data?.meta?.message,
                getCollectionsSuccess: false,
            };
        }
        case 'RESET_GET_COLLECTIONS': {
            return {
                ...state,
                getCollectionsSuccess: false,
                getCollectionsFailure: false,
                getCollectionsData: [],
                getCollectionsMetaMessage: null,
            };
        }

        case 'GET_COLLECTIONS_REPORT_SUCCESS': {
            return {
                ...state,
                getCollectionsReportSuccess: true,
                getCollectionsReportData: action.payload?.data?.data?.data,
                getCollectionsReportCount: action.payload?.data?.data?.meta?.total,
                getCollectionsReportFailure: false,
            };
        }
        case 'GET_COLLECTIONS_REPORT_FAILURE': {
            return {
                ...state,
                getCollectionsReportFailure: true,
                getCollectionsMetaMessage: action.payload?.data?.data?.meta?.message,
                getCollectionsReportSuccess: false,
            };
        }
        case 'RESET_GET_COLLECTIONS_REPORT': {
            return {
                ...state,
                getCollectionsReportSuccess: false,
                getCollectionsReportFailure: false,
                getCollectionsReportData: [],
                getCollectionsMetaMessage: null,
            };
        }

        case 'GET_COLLECTIONS_USER_REPORT_SUCCESS': {
            return {
                ...state,
                getCollectionsUserReportSuccess: true,
                getCollectionsUserReportData: action.payload?.data?.data?.data,
                getCollectionsUserReportFailure: false,
            };
        }
        case 'GET_COLLECTIONS_USER_REPORT_FAILURE': {
            return {
                ...state,
                getCollectionsUserReportFailure: true,
                getCollectionsMetaMessage: action.payload?.data?.data?.meta?.message,
                getCollectionsUserReportSuccess: false,
            };
        }
        case 'RESET_GET_COLLECTIONS_USER_REPORT': {
            return {
                ...state,
                getCollectionsUserReportSuccess: false,
                getCollectionsUserReportFailure: false,
                getCollectionsUserReportData: [],
                getCollectionsMetaMessage: null,
            };
        }

        case 'CREATE_COLLECTIONS_SUCCESS': {
            return {
                ...state,
                createCollectionsSuccess: true,
                createCollectionsData: action.payload?.data?.data?.data,
                getCollectionsMetaMessage: action.payload?.data?.data?.meta?.message,
                createCollectionsFailure: false,
            };
        }
        case 'CREATE_COLLECTIONS_FAILURE': {
            return {
                ...state,
                createCollectionsFailure: true,
                getCollectionsMetaMessage: action.payload?.data?.data?.meta?.message,
                createCollectionsSuccess: false,
            };
        }
        case 'RESET_CREATE_COLLECTIONS': {
            return {
                ...state,
                createCollectionsSuccess: false,
                createCollectionsFailure: false,
                createCollectionsData: null,
                getCollectionsMetaMessage: null,
            };
        }

        case 'UPDATE_COLLECTIONS_SUCCESS': {
            return {
                ...state,
                updateCollectionsSuccess: true,
                updateCollectionsData: action.payload?.data?.data?.data,
                getCollectionsMetaMessage: action.payload?.data?.data?.meta?.message,
                updateCollectionsFailure: false,
            };
        }
        case 'UPDATE_COLLECTIONS_FAILURE': {
            return {
                ...state,
                updateCollectionsFailure: true,
                getCollectionsMetaMessage: action.payload?.data?.data?.meta?.message,
                updateCollectionsSuccess: false,
            };
        }
        case 'RESET_UPDATE_COLLECTIONS': {
            return {
                ...state,
                updateCollectionsSuccess: false,
                updateCollectionsFailure: false,
                updateCollectionsData: null,
                getCollectionsMetaMessage: null,
            };
        }

        case 'DELETE_COLLECTIONS_SUCCESS': {
            return {
                ...state,
                deleteCollectionsSuccess: true,
                getCollectionsMetaMessage: action.payload?.data?.data?.meta?.message,
                deleteCollectionsFailure: false,
            };
        }
        case 'DELETE_COLLECTIONS_FAILURE': {
            return {
                ...state,
                deleteCollectionsFailure: true,
                getCollectionsMetaMessage: action.payload?.data?.data?.meta?.message,
                deleteCollectionsSuccess: false,
            };
        }
        case 'RESET_DELETE_COLLECTIONS': {
            return {
                ...state,
                deleteCollectionsSuccess: false,
                deleteCollectionsFailure: false,
                getCollectionsMetaMessage: null,
            };
        }

        default: {
            return state;
        }
    }
}
